/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-13T17:19:55.635
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentSerComplaintFollowup,
	listRentSerComplaintFollowupInit,
	listRentSerComplaintFollowupByAuthorizations,
	deleteRentSerComplaintFollowup
} from '@api/rentmanage/RentSerComplaintFollowup';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentSerComplaintFollowup({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintFollowup(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentSerComplaintFollowupByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintFollowupByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentSerComplaintFollowupInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintFollowupInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentSerComplaintFollowup({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentSerComplaintFollowup({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
